import axios from 'axios';
import { errorResponseHandler, responseHandler } from "../utilities/response";

export const getKPIMetrics = async () => {
  try {
    const data = await axios.get("/kpi");
    return responseHandler(data);
  } catch (err) {
    return errorResponseHandler(err);
  }
};